import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { paymentRecordOperationTypeMap, paymentTypeInfoMap } from '../../constants/policy/common';
import { getPaymentScheduleStatusMap } from '../../constants/quote';
import { getPaymentRecordSourceMap } from '../../localeConstants/policy/common';
import { formatCommonDateStr } from '../time';
/**
 * Maps a billing schedule item into a shared policy payment table row.
 * Mutates and returns the passed-in item, so pass a cloned item.
 */

export var handlePolicyPaymentScheduleTableRow = function handlePolicyPaymentScheduleTableRow(item) {
  item.type = 'schedule';

  if (item.is_policy_update_adjustment) {
    item.paymentTypeText = paymentRecordOperationTypeMap.policy_modify.label;
  } else {
    item.paymentTypeText = paymentTypeInfoMap.payment.label;
  }

  item.adminFeeText = item.combineUnderwritingFeeText;
  return item;
};
/**
 * Maps a cash payment record into a shared policy payment table row.
 * paymentSourceText falls back to the raw payment_source value so sources added
 * on the backend still show up before getPaymentRecordSourceMap is extended.
 */

export var handlePolicyPaymentRecordTableRow = function handlePolicyPaymentRecordTableRow(item) {
  var _paymentRecordOperati, _getPaymentScheduleSt, _getPaymentRecordSour;

  return _objectSpread(_objectSpread({}, item), {}, {
    type: 'actual',
    monthText: formatCommonDateStr(item.statement_date),
    paymentTypeText: (_paymentRecordOperati = paymentRecordOperationTypeMap[item.operation_type]) === null || _paymentRecordOperati === void 0 ? void 0 : _paymentRecordOperati.label,
    paymentStatusText: (_getPaymentScheduleSt = getPaymentScheduleStatusMap()[item.payment_status]) === null || _getPaymentScheduleSt === void 0 ? void 0 : _getPaymentScheduleSt.label,
    paymentSourceText: ((_getPaymentRecordSour = getPaymentRecordSourceMap()[item.payment_source]) === null || _getPaymentRecordSour === void 0 ? void 0 : _getPaymentRecordSour.label) || item.payment_source
  });
};
/**
 * Judges whether a cash payment record mirrors a billing schedule installment (policy premium / policy
 * modify, plus agent bill payment when the schedule rows already represent that money). Such records are
 * excluded when schedule rows are displayed alongside, to avoid double counting. For agency bill policies
 * the schedule rows are not shown, so agent bill payment records are kept via includeAgentBillPayment: false.
 */

export var judgePolicyPaymentRecordMirrorsSchedule = function judgePolicyPaymentRecordMirrorsSchedule(item, options) {
  var _ref = options || {},
      _ref$includeAgentBill = _ref.includeAgentBillPayment,
      includeAgentBillPayment = _ref$includeAgentBill === void 0 ? true : _ref$includeAgentBill;

  var operationTypes = [paymentRecordOperationTypeMap.policy_modify.value, paymentRecordOperationTypeMap.policy_premium.value];

  if (includeAgentBillPayment) {
    operationTypes.push(paymentRecordOperationTypeMap.agent_bill_payment.value);
  }

  return operationTypes.includes(item === null || item === void 0 ? void 0 : item.operation_type);
};